package org.example.zone360.models

import kotlinx.serialization.Serializable

@Serializable
data class EditSummaryResponse(
    val response: EditSummaryData,
)
@Serializable
data class EditSummaryData(
    val summary: String = "",
    val summaryRevision: Int = 0,
)

@Serializable
data class EditSummaryRequest(
    val text: String,
    val organization: String,
    val repair_text_before_analysis: Boolean,
    val session_type: String,
    val coach_name: String,
    val player_name: String,
    val domain_type: String,
    val get_summary: Boolean,
    val summary_only: Boolean,
    val edit_only: Boolean,
    val get_insights: Boolean,
    val session_id: String,
    val language: String,
)
